export function countWeeks(days: DaysCount): WeeksCount {
  return Math.ceil(days / 7);
}
